import * as React from 'react';
import { DefaultButton, IIconProps } from 'office-ui-fabric-react';
import './Dashboard.scss';
import Header from '../../common/Header';
import { IDashboardProps, IDashboardState } from '../../../interfaces/IDashboard';
import history from '../../../lib/history';

export interface IButtonExampleProps {
  disabled?: boolean;
  checked?: boolean;
}

const CreateOrderIconProps: IIconProps = { iconName: 'CircleAdditionSolid', className: 'text-danger ms-fontSize-42' };
const OrderHistoryIconProps: IIconProps = { iconName: 'BulletedList2', className: 'text-danger ms-fontSize-42' };

class Dashboard extends React.Component<IDashboardProps, IDashboardState> {
  constructor(props: IDashboardProps) {
    super(props);

    this.state = {
    }
  }

  componentDidMount() {}

  createOrder = () => {
    history.push("/neworderbasicdetails");
  }

  orderHistory = () => {
    history.push("/orderhistory");
  }

  public render() {
    return (
      <div className="page pb-5">
        <Header isBackVisible={false} />
        <div className="container mt-5 mTop8">
          <div className="ms-Grid">
            <div className="ms-Grid-row row justify-content-center">
              <div className="ms-Grid text-center col-md-5">
                <DefaultButton className="btn-block p-3 ms-fontSize-18" iconProps={CreateOrderIconProps} text="Meerwerkbon toevoegen"
                  onClick={() => this.createOrder()} allowDisabledFocus />
              </div>
              <div className="w-100"></div>
              <div className="ms-Grid text-center mt-4 col-md-5">
                <DefaultButton className="btn-block p-3 ms-fontSize-18" iconProps={OrderHistoryIconProps} text="Meerwerkbon geschiedenis"
                  onClick={() => this.orderHistory()} allowDisabledFocus />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Dashboard;